export default "__VITE_ASSET__CagQr$er__"